import React from 'react'

export default function SectionTitle(props) {
  return (
    <h6 className='text-center text-[#F64B4B] text-[16px] font-semibold'>{props.title}</h6>
  )
}
